export enum SearchDetailLevel {
  SCORE = 'score',
  BEST_PATH = 'best_path',
  ALL_PATHS = 'all_paths',
}
export enum LegacySearchDetailLevel {
  _LEGACY_SYNTHESIS = 'synthesis',
}

export enum SearchLength {
  SHORT = 'short',
  REGULAR = 'regular',
  SINGLE_STEP = 'single_step',
}

export enum SearchSynthesisScale {
  KILOGRAM = 'kilogram',
  MOLAR = 'molar',
  MILLIMOLAR = 'millimolar',
  MICROMOLAR = 'micromolar',
}

export enum SearchReactionConfidenceThreshold {
  HIGH = 'high',
  LOW = 'low',
}

export enum SearchInvalidTargetStrategy {
  PASS = 'pass',
  REJECT = 'reject',
}

export enum SearchSource {
  APIv2 = 'api_v2',
  UI = 'web',
}

export enum SearchResultStatus {
  COMPLETED = 'ok',
  FAILED = 'error',
  RUNNING = 'running',
}

export enum SearchCreditCycle {
  MONTH = 'month',
  NONE = 'none',
}

export enum CreditTransactionType {
  CREDIT = 'credit',
  DEBIT = 'debit',
  REFUND = 'refund',
}
